
import { defineComponent, ref, defineAsyncComponent, onMounted, computed} from 'vue';

import Footer from '@components/common/Footer.vue';

import bridge from '@utiles/bridge';
import { openService } from '@utiles/sdkCtrl';
import { useCompData } from '@plugins/CompData/index';
import { getParam, IS_FROM_SDK } from '@utiles/index';
import { useStore } from 'vuex';
import { UPDATE_HAS_SHOW_INTRO } from '@/resource/store/mutationType';
import { gameId } from '@config/gamePageConfig';
export default defineComponent({
  name: 'Layout',
  methods: {
    gameId() {
      return gameId
    }
  },
  setup() {
    const store = useStore();
    let showPageBar = ref(false);
    let {
      isShowTopBar,
      isShowNavBar,
      showSdkTopBar,
      showSocialBtn,
      socialBtnList,
      showCloseBtn,
      showBackBtn,
      showNavIntroBtn,
      showIntroFirstOpen,
      showOrientation,
    } = useCompData('layout');
    const showCloseBtnManual = ref(true);
    const showExtraPopup = ref(
      store.state.hasShowIntro ? false : showIntroFirstOpen,
    );
    const isRunInsdk = computed(() => {
      return bridge.runInsdk()
    })
    onMounted(() => {
      !showSdkTopBar &&
        bridge.callSdkMethod('hideNavigationView', {}, res => {
          if (res && +res.result === 1) {
            showPageBar.value = true;
          }
        });
    });

    // 网页打开，默认显示页面功能按钮
    if (!getParam('devicePlate')) {
      showPageBar.value = true;
    }

    // 导航栏额外按钮处理
    const extraHandle = () => {
      showExtraPopup.value = true;
    };

    const closeExtraPopup = () => {
      store.commit(UPDATE_HAS_SHOW_INTRO, true);
    };

    // 凡人修仙外跳打开特殊判断
    const hideCloseBtnHandle = () => {
      const devicePlate = getParam('devicePlate') || '';
      if (!devicePlate) {
        showCloseBtnManual.value = false;
      }
    };
    const gameId =
      getParam('gameId') || getParam('gameID') || getParam('game_id') || '';
    if (+gameId === 275) {
      hideCloseBtnHandle();
    }

    return {
      isShowTopBar,
      isShowNavBar,
      showSdkTopBar,
      showPageBar,
      showSocialBtn,
      socialBtnList,
      showCloseBtn,
      showBackBtn,
      showCloseBtnManual,
      showNavIntroBtn,
      showExtraPopup,
      showOrientation,
      IS_FROM_SDK,
      closeExtraPopup,
      extraHandle,
      openService,
      isRunInsdk
    };
  },
  components: {
    Footer,
    NavBar: defineAsyncComponent(() => import('@components/common/NavBar.vue')),
    TopBar: defineAsyncComponent(() => import('@components/common/TopBar.vue')),
    BackBtn: defineAsyncComponent(() =>
      import('@components/common/BackBtn.vue'),
    ),
    CloseBtn: defineAsyncComponent(() =>
      import('@components/common/CloseBtn.vue'),
    ),
    SocialBtn: defineAsyncComponent(() =>
      import('@components/common/SocialBtn.vue'),
    ),
    IntroBattlePopup: defineAsyncComponent(() =>
      import('@components/char/IntroBattlePopup.vue'),
    ),
    Orientation: defineAsyncComponent(() =>
      import('@components/common/Orientation.vue'),
    ),
  },
});
